import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { useDownloadInvoicePreview } from '../../hooks/invoice/useDownloadInvoicePreview';

export const InvoicePreviewDownloaderComponent = ({
  title,
  titleTooltip,
  loading,
  onClick,
}) => (
  <Tooltip title={titleTooltip || 'Download Report Preview'} placement="left">
    <Button
      loading={loading}
      icon={<i className="fa fa-eye"></i>}
      onClick={onClick}
    >
      {title}
    </Button>
  </Tooltip>
);
InvoicePreviewDownloaderComponent.propTypes = {
  title: PropTypes.string,
  titleTooltip: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

const InvoicePreviewDownloader = ({ invoiceId, invoiceNo, isShowText = true }) => {
  const { loading: downloadingReport, getCaseReportPreview } =
    useDownloadInvoicePreview();

  const handlePreviewReport = async () => {
    await getCaseReportPreview(invoiceId, invoiceNo);
  };

  return (
    <InvoicePreviewDownloaderComponent
      title={isShowText ? 'Preview' : ''}
      titleTooltip={'Download Report Preview'}
      loading={downloadingReport}
      onClick={handlePreviewReport}
    />
  );
};

InvoicePreviewDownloader.propTypes = {
  invoiceId: PropTypes.number,
  invoiceNo: PropTypes.string,
  isShowText: PropTypes.bool,
};

export default InvoicePreviewDownloader;
